import { apiClient } from '@/lib/api';
import type { ScheduledJobsResponse, UnscheduledJobsResponse } from '@skewb-works/contracts';

export interface UnscheduledJobsParams {
  limit?: number;
  skip?: number;
  search?: string;
  priority_id?: number[];
  job_category_id?: number[];
}

export async function getUnscheduledJobs(
  params: UnscheduledJobsParams = {},
): Promise<UnscheduledJobsResponse> {
  const searchParams = new URLSearchParams();
  searchParams.set('limit', String(params.limit ?? 100));
  searchParams.set('skip', String(params.skip ?? 0));
  if (params.search) searchParams.set('search', params.search);
  if (params.priority_id?.length) searchParams.set('priority_id', params.priority_id.join(','));
  if (params.job_category_id?.length)
    searchParams.set('job_category_id', params.job_category_id.join(','));
  searchParams.set('_t', String(Date.now()));

  return apiClient.get<UnscheduledJobsResponse>(
    `/works-lite/planner/unscheduled-jobs?${searchParams.toString()}`,
  );
}

export interface ScheduledJobsParams {
  limit?: number;
  skip?: number;
  search?: string;
}

export async function getScheduledJobs(
  params: ScheduledJobsParams = {},
): Promise<ScheduledJobsResponse> {
  const searchParams = new URLSearchParams();
  searchParams.set('limit', String(params.limit ?? 200));
  searchParams.set('skip', String(params.skip ?? 0));
  if (params.search) searchParams.set('search', params.search);
  searchParams.set('_t', String(Date.now()));

  return apiClient.get<ScheduledJobsResponse>(
    `/works-lite/planner/scheduled-jobs?${searchParams.toString()}`,
  );
}
